const actionTypes = {
    GET_REF_DATA_EVENTS_BY_RECON_SUCCESS: 'GET_REF_DATA_EVENTS_BY_RECON_SUCCESS',
    GET_CONNECTION_DETAILS: 'GET_CONNECTION_DETAILS',
    SET_DB_COLUMNS: 'SET_DB_COLUMNS',
    GET_SERVER_FOLDERS: 'GET_SERVER_FOLDERS',
    GET_XSD_TEMPLATES: 'GET_XSD_TEMPLATES',
    SET_AUTO_MAP: 'SET_AUTO_MAP'
};

export default actionTypes;
